/** The sections of the SIT settings page, in page order; `key` is the anchor (`#settings-<key>`). */
export const SETTINGS_SECTIONS = [
    {key: 'general', label: 'General'},
    {key: 'currencies', label: 'Currencies'},
    {key: 'clusters', label: 'Clusters'},
    {key: 'companies', label: 'Companies'},
    {key: 'rates', label: 'Conversion rates'},
    {key: 'levers', label: 'Levers'},
] as const;

export type SettingsSectionKey = typeof SETTINGS_SECTIONS[number]['key'];

export function scrollToSettings(key: SettingsSectionKey | string) {
    document.getElementById(`settings-${key}`)?.scrollIntoView({behavior: 'smooth', block: 'start'});
}
